import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: () => import(/* webpackChunkName: "index" */ '../views/IndexView.vue')
  // },
  // {
  //   path: '/',
  //   name: 'index',
  //   component: () => import(/* webpackChunkName: "index" */ '../views/403View.vue')
  // }, 
   {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '../views/AppView.vue')
  },
  // 游戏详情页面 - 默认显示成就页面
  // {
  //   path: '/game/:id',
  //   name: 'game',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game/AchievementsView.vue')
  // },
  // 游戏成就页面
  // {
  //   path: '/game/:id/achievements',
  //   name: 'achievements',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game/AchievementsView.vue')
  // },
  // 游戏攻略页面
  // {
  //   path: '/game/:id/walkthrough',
  //   name: 'walkthrough',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game/WalkthroughView.vue')
  // },
  // 游戏评测页面
  // {
  //   path: '/game/:id/review',
  //   name: 'review',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game/ReviewView.vue')
  // },
  // 游戏攻略详情页面
  // {
  //   path: '/game/:id/walkthrough/:guideId',
  //   name: 'walkthrough-detail',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game/WalkthroughDetailView.vue')
  // },
  // Special 目录路由
  {
    path: '/special/update-data',
    name: 'update-data',
    component: () => import(/* webpackChunkName: "special" */ '../views/App/Special/UpdateDataView.vue')
  },
  {
    path: '/special/user-update',
    name: 'user-update',
    component: () => import(/* webpackChunkName: "special" */ '../views/App/Special/UserUpdateView.vue')
  },
  {
    path: '/special/delete-account',
    name: 'delete-account',
    component: () => import(/* webpackChunkName: "special" */ '../views/App/Special/DeleteAccountView.vue')
  },
  {
    path: '/special/xgp365-ad',
    name: 'xgp365-ad',
    component: () => import(/* webpackChunkName: "special" */ '../views/App/Special/Xgp365AdView.vue')
  },
  // PriceHistory 目录路由
  {
    path: '/price-history',
    name: 'price-history',
    component: () => import(/* webpackChunkName: "price-history" */ '../views/App/PriceHistory/IndexView.vue')
  },
  // ThirdMall 目录路由
  {
    path: '/third-mall',
    name: 'third-mall',
    component: () => import(/* webpackChunkName: "third-mall" */ '../views/App/ThirdMall/IndexView.vue')
  },
  {
    path: '/third-mall/detail',
    name: 'third-mall-detail',
    component: () => import(/* webpackChunkName: "third-mall" */ '../views/App/ThirdMall/DetailView.vue')
  },
  // 添加通配符路由，捕获所有未匹配的路径
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    const hostname = window.location.hostname
    
    // 根据不同的域名加载不同的首页组件
    if (hostname.includes('corehalo.com')) {
      to.matched[0].components.default = () => import(/* webpackChunkName: "index" */ '../views/403View.vue')
    } else {
      to.matched[0].components.default = () => import(/* webpackChunkName: "index" */ '../views/AppView.vue')
    }
  }
  next()
})

export default router
